<div class="logo" *ngIf="isMobileMenu()">
  <!-- <a class="simple-text logo-mini">
        <div class="logo-img">
            <img src="/assets/img/link_2015.png" />
        </div>
    </a>
    <a class="simple-text logo-normal">
        {{proyectName}}
    </a> -->
</div>

<div class="sidebar-wrapper">
  <div class="user" *ngIf="isMobileMenu()">
    <div class="photo">
      <i class="material-icons md-36">account_circle</i>
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse-left"
        href="#userCollapse-left"
        class="collapsed"
        aria-expanded="false"
      >
        <span>
          {{ usuario && usuario.Name }}
          <br />
          <small>{{ empresa && empresa }}</small>
        </span>
      </a>
      <div class="collapse-left" id="userCollapse-left">
        <ul class="nav">
          <li class="nav-item">
            <a href="directlogin" class="nav-link" (click)="logOutClick()">
              <i class="material-icons">exit_to_app</i>Cerrar sesión
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- <div class="user"><div class="photo">
        <a  (click)="minimizeSidebar()">></a>
      </div>
      <div class="user-info">
        <span>colapsar
        <a  (click)="minimizeSidebar()"> <</a>
      </span>
      </div>

    </div> -->

  <div class="collapse-left" *ngIf="!isMobileMenu()">
    <a class="simple-text collapse-left-mini">
      <div class="collapse-left-button">
        <a (click)="minimizeSidebar()" class="btn btn-just-icon btn-link">
          <i
            class="material-icons text_align-center visible-on-sidebar-regular"
          >chevron_left</i>
          <i
            class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
          >
            chevron_right
          </i>
        </a>
      </div>
    </a>
    <a
      (click)="minimizeSidebar()"
      class="simple-text collapse-left-normal linkCollapse-left"
    >
      <span class="visible-on-sidebar-regular"> colapsar menú </span>
      <span class="visible-on-sidebar-mini">
        <!--  fijar menú -->
      </span>
      <!--
      > -->
    </a>
  </div>

  <ul class="nav">
    <ng-container *ngFor="let menuItem of menuItems">
      <li
        routerLinkActive="active"
        class="{{ menuItem.class }}"
        *ngxPermissionsOnly="menuItem.roles"
      >
        <a class="nav-link" [routerLink]="[menuItem.path]"  placement="right"
        ngbTooltip="{{ menuItem.title }}"  [disableTooltip]="!sidebarMiniActive" container="body">
          <i class="material-icons">
          <fa-icon [icon]="menuItem.icon"></fa-icon>
        </i>
          <p>{{ menuItem.title }}</p>
        </a>
      </li>
    </ng-container>
  </ul>

  <!-- <ul class="nav">
    <ng-container *ngFor="let menuItem of menuItems">
      <li
        routerLinkActive="active"
        class="{{ menuItem.class }}"
        *ngxPermissionsOnly="menuItem.roles"
      >
        <a
          class="nav-link"
          placement="right"
          ngbTooltip="{{ menuItem.title }}"
          data-toggle="collapse"
          [disableTooltip]="!sidebarMiniActive"
          (click)="menuItem.isCollapsed = !menuItem.isCollapsed"
          [attr.aria-expanded]="!menuItem.isCollapsed"
          [attr.aria-controls]="menuItem.path"
          container="body"
          *ngIf="menuItem.isParent; else simpleOption"
        >
          <i class="material-icons">
            <fa-icon [icon]="menuItem.icon"></fa-icon>
          </i>
          <p>{{ menuItem.title }} <b class="caret"></b></p>
        </a>

        <ng-template #simpleOption>
          <a
            class="nav-link"
            [routerLink]="[menuItem.path]"
            ngbTooltip="{{ menuItem.title }}"
            [disableTooltip]="!sidebarMiniActive"
            placement="right"
            container="body"
          >
            <i class="material-icons">
              <fa-icon [icon]="menuItem.icon"></fa-icon>
            </i>
            <p>{{ menuItem.title }}</p>
          </a>
        </ng-template>

        <div
          id="menuItem.path"
          class="collapse"
          *ngIf="menuItem.isParent"
          [(ngbCollapse)]="menuItem.isCollapsed"
          [animation]="true"

        >
          <ul class="nav">
            <li
              routerLinkActive="active"
              *ngFor="let childMenuItem of menuItem.childs"
              class="nav-item"
            >
              <a [routerLink]="[childMenuItem.path]" class="nav-link"   ngbTooltip="{{ childMenuItem.title }}"
              [disableTooltip]="!sidebarMiniActive"
              placement="right"
              container="body">
                <span class="sidebar-mini">
                  <i class="material-icons">
                    <fa-icon [icon]="childMenuItem.icon"></fa-icon>
                  </i>
                </span>
                <span class="sidebar-normal">{{ childMenuItem.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ng-container>
  </ul> -->
</div>

<!-- <div class="logo">
    <a class="simple-text logo-mini">
        <div class="logo-img">
            <img src="/assets/img/link_2015.png" />
        </div>
    </a>
    <a class="simple-text logo-normal">
        {{proyectName}}
    </a>
</div>



<div class="sidebar-wrapper">
    <div class="user">
        <div class="photo">
            <i class="material-icons md-36">account_circle</i>
        </div>
        <div class="user-info">
            <a data-toggle="collapse-left" href="#userCollapse-left" class="collapsed">
                <span>
                    {{user.UserName}}
                    <br>
                    <small>{{user.CompanyName}}</small>

                </span>
            </a>
            <div class="collapse-left" id="userCollapse-left" *ngIf="isMobileMenu()">
                <ul class="nav">
                    <li class="nav-item">
                        <a href="login" class="nav-link" (click)="logOutClick()">
                            <i class="material-icons">exit_to_app</i>Cerrar sessión
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>


        <ul class="nav">
            <ng-container *ngFor="let menuItem of menuItems">
                <li routerLinkActive="active" class="{{menuItem.class}}" *ngxPermissionsOnly="menuItem.roles">
                    <a class="nav-link" data-toggle="collapse-left" href="#{{menuItem.path}}" *ngIf="menuItem.isParent;else simpleOption">
                        <i class="material-icons">{{menuItem.icon}}</i>
                        <p>
                            {{menuItem.title}}
                            <b class="caret"></b>
                        </p>
                    </a>
                    <ng-template #simpleOption>
                        <a class="nav-link" [routerLink]="[menuItem.path]">
                            <i class="material-icons">{{menuItem.icon}}</i>
                            <p>{{menuItem.title}}</p>
                        </a>
                    </ng-template>

                    <div class="collapse-left" *ngIf="menuItem.isParent" id="{{menuItem.path}}">
                        <ul class="nav">
                            <li routerLinkActive="active" *ngFor="let childMenuItem of menuItem.childs" class="nav-item">
                                <a [routerLink]="[childMenuItem.path]" class="nav-link">
                                    <span class="sidebar-mini">{{childMenuItem.sortTitle}}</span>
                                    <span class="sidebar-normal">{{childMenuItem.title}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ng-container>
        </ul>

</div> -->
